import React from 'react';
import { 
  Plus, Package, Truck, ClipboardCheck, FileText, Building2, 
  LogOut, Home, Navigation
} from 'lucide-react';

// Sidebar Menu Item
const MenuItem = ({ icon: Icon, label, active, onClick, badge }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
      active 
        ? 'bg-[#36e961] text-[#0a3042] font-semibold' 
        : 'text-gray-300 hover:bg-white/10 hover:text-white'
    }`}
    data-testid={`sidebar-${label.toLowerCase().replace(' ', '-')}`}
  >
    <Icon className="w-5 h-5" />
    <span className="text-sm">{label}</span>
    {badge && (
      <span className="ml-auto bg-[#36e961] text-[#0a3042] text-xs font-bold px-2 py-0.5 rounded-full">
        {badge}
      </span>
    )}
  </button>
);

const ClientSidebar = ({ user, activeTab, onNavigate, onCreateService, onLogout, stats = {} }) => {
  return (
    <aside className="w-64 bg-[#0a3042] flex flex-col shrink-0">
      {/* Logo */}
      <div className="p-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center p-1.5">
            <img 
              src="https://customer-assets.emergentagent.com/job_927b78ff-6137-4209-a5c6-1343491e5188/artifacts/04fvidd7_1c.png" 
              alt="AutoGo Logo" 
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <h1 className="text-white font-bold text-lg">AutoGo</h1>
            <p className="text-gray-400 text-xs">Panel de Cliente</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        <p className="text-gray-500 text-xs uppercase tracking-wider px-4 mb-2">General</p>
        <MenuItem 
          icon={Home} 
          label="Dashboard" 
          active={activeTab === 'dashboard'}
          onClick={() => onNavigate('dashboard')}
        />
        <MenuItem 
          icon={Package} 
          label="Mis Servicios" 
          active={activeTab === 'services'}
          onClick={() => onNavigate('services')}
          badge={stats.total > 0 ? stats.total : null}
        />
        <MenuItem 
          icon={Plus} 
          label="Crear Servicio" 
          active={activeTab === 'create'}
          onClick={() => {
            onNavigate('create');
            onCreateService?.();
          }}
        />

        <p className="text-gray-500 text-xs uppercase tracking-wider px-4 mb-2 mt-6">Seguimiento</p>
        <MenuItem 
          icon={Navigation} 
          label="GPS en Vivo" 
          active={activeTab === 'gps'}
          onClick={() => onNavigate('gps')}
          badge={stats.in_transit > 0 ? stats.in_transit : null}
        />
        <MenuItem 
          icon={Truck} 
          label="Estado Servicios" 
          active={activeTab === 'deliveries'}
          onClick={() => onNavigate('deliveries')}
          badge={stats.in_progress > 0 ? stats.in_progress : null}
        />
        <MenuItem 
          icon={ClipboardCheck} 
          label="Peritajes" 
          active={activeTab === 'inspections'}
          onClick={() => onNavigate('inspections')}
        />

        <p className="text-gray-500 text-xs uppercase tracking-wider px-4 mb-2 mt-6">Cuenta</p>
        <MenuItem 
          icon={FileText} 
          label="Facturas" 
          active={activeTab === 'invoices'}
          onClick={() => onNavigate('invoices')}
        />
        <MenuItem 
          icon={Building2} 
          label="Mi Empresa" 
          active={activeTab === 'profile'}
          onClick={() => onNavigate('profile')}
        />
      </nav>

      {/* User & Logout */}
      <div className="p-4 border-t border-white/10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-gray-600 rounded-full flex items-center justify-center text-white font-bold">
            {user?.company_name?.[0] || user?.name?.[0] || 'C'}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white text-sm font-medium truncate">{user?.company_name || user?.name}</p>
            <p className="text-gray-400 text-xs truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition-all text-sm"
          data-testid="sidebar-logout"
        >
          <LogOut className="w-4 h-4" />
          Cerrar Sesión
        </button>
      </div>
    </aside>
  );
};

export default ClientSidebar;
